import React from 'react';
import PropTypes from 'prop-types';
import { values } from 'lodash';
import AnimationView from '../animation/AnimationView';
import SvgIcon from '../components/SvgIcon';
import { ApolloContext } from '../../ApolloContextProvider';

export default class Avatar extends React.Component {
    static Position = {
        CENTER: 'avatar-center',
        MIDDLE_LEFT: 'avatar-middle-left',
        MIDDLE_FAR_LEFT: 'avatar-middle-far-left',
        START_MIDDLE_LEFT: 'avatar-start-middle-left',
        LOWER_LEFT: 'avatar-lower-left',
        LOWER_FAR_LEFT: 'avatar-lower-far-left',
        OFFSCREEN: 'avatar-offscreen',
        HIDDEN: 'avatar-hidden',
    };

    constructor(props) {
        super(props);
        this.hasBranch = this.hasBranch.bind(this);
        this.onAvatarClick = this.onAvatarClick.bind(this);
        this.avatarAnimation = this.avatarAnimation.bind(this);
        window.avatar = this;
    }

    componentWillUnmount() {
        this.props.stopSpeaking();
    }

    onAvatarClick() {
        if (!this.props.isScreenBlocked && this.props.owlyCanSpeak) {
            this.props.onClick(this.props.instructions, this.props.postAudioCallback);
        }
    }

    hasBranch() {
        return this.props.position !== Avatar.Position.CENTER
            || this.props.position !== Avatar.Position.HIDDEN;
    }

    avatarAnimation() {
        return this.props.isSpeaking ? 'speaking' : 'default';
    }

    render() {
        const { isAnimationVisualReduced } = this.context;
        return (
            <div
                className={`assessment-window avatar-window avatar-transition
                    ${this.props.position} ${this.props.isScreenBlocked ? 'block-screen' : ''} ${this.props.isScreenGreyedOut ? 'disabled-measure' : ''}`}>
                {this.hasBranch()
                    && (
                        <SvgIcon
                            ariaHidden={true}
                            ariaLabel="Branch"
                            id="branch"
                            class="owly-perch"
                        />
                    )}
                <AnimationView
                    class="owly"
                    animationId="owly2"
                    tabIndex={this.props.instructions.length === 0 ? '-1' : '0'}
                    animation={this.avatarAnimation()}
                    onClick={this.onAvatarClick}
                    onAnimationReady={this.props.onAnimationReady}
                    onTransitionEnd={this.props.onTransitionEnd}
                    onFileLoadingError={this.props.onFileLoadingError}
                    isAnimationVisualReduced={isAnimationVisualReduced} />
            </div>
        );
    }
}

Avatar.contextType = ApolloContext;

Avatar.propTypes = {
    onClick: PropTypes.func.isRequired,
    postAudioCallback: PropTypes.func,
    instructions: PropTypes.array,
    position: PropTypes.oneOf(values(Avatar.Position)),
    isSpeaking: PropTypes.bool.isRequired,
    stopSpeaking: PropTypes.func.isRequired,
    isScreenBlocked: PropTypes.bool,
    isScreenGreyedOut: PropTypes.bool,
    onAnimationReady: PropTypes.func,
    onTransitionEnd: PropTypes.func,
    onFileLoadingError: PropTypes.func,
    owlyCanSpeak: PropTypes.bool,
};

Avatar.defaultProps = {
    instructions: [],
    postAudioCallback: undefined,
    position: Avatar.Position.MIDDLE_LEFT,
    isScreenBlocked: false,
    isScreenGreyedOut: false,
    onAnimationReady: undefined,
    onTransitionEnd: undefined,
    onFileLoadingError: () => { },
    owlyCanSpeak: true,
};
